import { login } from '@/api/user'
import { showNotice, getLoginErrorMessage } from '@/utils/tool'

// GIS script 全站只載入一次，跨元件共用
let googleScriptPromise = null

export default {
  computed: {
    googleLoginClientId() {
      return this.$store.getters.googleLoginClientId
    },
    showGoogleLogin() {
      return this.$store.getters.permissionInfo.enable_google_login === 1 && !!this.googleLoginClientId
    }
  },
  methods: {
    loadGoogleScript() {
      if (window.google && window.google.accounts && window.google.accounts.id) {
        return Promise.resolve()
      }
      if (!googleScriptPromise) {
        googleScriptPromise = new Promise((resolve, reject) => {
          const script = document.createElement('script')
          script.src = 'https://accounts.google.com/gsi/client'
          script.async = true
          script.defer = true
          script.onload = resolve
          script.onerror = reject
          document.head.appendChild(script)
        })
      }
      return googleScriptPromise
    },
    // buttonText: GIS 官方按鈕文字，如 'signup_with'、'signin_with'
    initGoogleLogin(buttonText) {
      this.loadGoogleScript().then(() => {
        if (!this.$refs.googleButton) {
          return
        }
        window.google.accounts.id.initialize({
          client_id: this.googleLoginClientId,
          callback: this.handleGoogleResponse
        })
        window.google.accounts.id.renderButton(this.$refs.googleButton, {
          type: 'standard',
          theme: 'outline',
          size: 'large',
          text: buttonText || 'continue_with',
          width: this.$refs.googleButton.offsetWidth || 320
        })
      }).catch(err => {
        console.log(err)
      })
    },
    handleGoogleResponse(response) {
      if (!response || !response.credential) {
        return
      }
      this.actionLoading = true
      login({
        social_type: 'google',
        credential: response.credential
      }).then(res => {
        if (res.data.data.code === 0) { // 登入成功（未綁定帳號時後端會自動建立會員）
          // 後端回應若未帶 social_type，保底標記為 google，供第三方帳號限制判斷
          this.$store.commit('SET_SOCIAL_TYPE', res.data.data.social_type || 'google')
          this.onGoogleLoginSuccess(res) // 由掛載元件實作後續流程
        } else if (res.data.data.code === 2201) { // 打開 username 彈窗
          this.$store.commit('SET_SOCIAL_TYPE', res.data.data.social_type || 'google')
          // 暫存後端回傳的正式 token 與 google credential
          this.openSetUsername(res.data.data.token, response.credential)
        } else {
          // 依錯誤代碼顯示對應多語系訊息，未知代碼退回後端 msg
          showNotice(getLoginErrorMessage(res.data.data.code) || res.data.msg)
        }
      }).catch(error => {
        // 錯誤格式同 /user/login 一般登入：code 位於 error.response.data.data.code[0]
        if (error && error.response) {
          const errorData = error.response.data.data
          const errorCode = errorData && errorData.code ? errorData.code : ''
          showNotice(getLoginErrorMessage(errorCode) || error.response.data.msg)
        } else {
          console.log(error)
        }
      }).finally(() => {
        this.actionLoading = false
      })
    },
    // code 2201：暫存後端回傳的正式會員 token 與本次 google credential
    // 關閉登入/註冊彈窗、開啟設定 username 彈窗。
    // 這顆 token 只在設定 username 流程中，由 update-username／relogin 主動帶進 request body；
    // credential 供成功後 relogin 重打 login 時一併帶上
    openSetUsername(tokenData, credential) {
      if (tokenData && tokenData.token) {
        this.$store.commit('SET_SET_USERNAME_TOKEN', tokenData.token)
      }
      if (credential) {
        this.$store.commit('SET_SET_USERNAME_CREDENTIAL', credential)
      }
      this.$store.commit('SET_LOGIN_OPEN', false)
      this.$store.commit('SET_REGISTER_OPEN', false)
      this.$store.commit('SET_SET_USERNAME_OPEN', true)
    }
  }
}
